import { Component, OnInit, input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-experience',
    templateUrl: './experience.component.html',
    styleUrl: './experience.component.scss',
    imports: [DatePipe]
})
export class ExperienceComponent implements OnInit {
	readonly experience = input<any>();
	readonly settings = input<any>();
	readonly isExpLabelShow = input<any>();

	public isEmploymentHistoryView: boolean;
	public isReferencesView: boolean;
	public isSeminarView: boolean;
	public isPublicationsView: boolean;
	public isAffiliationsView: boolean;

	ngOnInit(): void {
		this.isEmploymentHistoryView = this.settings()
			?.filter((e: any) => e.name == 'Employment History')
			.map((e: any) => e.active)[0];
		const settings = this.settings();
  this.isReferencesView = settings
			?.filter((e: any) => e.name == 'References')
			.map((e: any) => e.active)[0];
		this.isSeminarView = settings
			?.filter((e: any) => e.name == 'Seminar / Conferences / Courses')
			.map((e: any) => e.active)[0];
		this.isPublicationsView = settings
			?.filter((e: any) => e.name == 'Publications')
			.map((e: any) => e.active)[0];
		this.isAffiliationsView = settings
			?.filter((e: any) => e.name == 'Affiliations')
			.map((e: any) => e.active)[0];
	}
}
